<template>
  <v-flex xl4 md7 sm9 xs12>
    <page-toolbar>
      <kendo-button icon="add" title="Add" v-show="editable" @click="addNew"> </kendo-button>
      <kendo-button icon="excel" title="Export to Excel" @click="exportToExcel"> </kendo-button>
    </page-toolbar>
    <kendo-grid
      height="calc(100vh - 165px)"
      :dataSource="dataSource"
      :editable="editable && 'inline'"
      ref="grid"
      :filterable="true"
      :sortable="true"
      :pageable-always-visible="true"
      :columns="columns"
    >
    </kendo-grid>
  </v-flex>
</template>
<script>
import {mapGetters} from 'vuex'
import {
  jsonDropDownEditor,
  datePickerEditor,
  readOnlyEditor,
  numericEditor,
} from '@/helpers/kendo-editors'
import PageToolbar from '@/components/PageToolbar'

export default {
  data() {
    return {
      dataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 30,
        transport: {
          read: {
            type: 'GET',
            url: '/api/heroux/fxRate',
            dataType: 'json',
          },
          create: {
            type: 'POST',
            url: '/api/heroux/fxRate',
            dataType: 'json',
          },
          update: {
            type: 'PUT',
            url: '/api/heroux/fxRate',
            dataType: 'json',
          },
          destroy: {
            type: 'DELETE',
            url: '/api/heroux/fxRate',
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'rateId',
            fields: {
              rateId: {type: 'number', defaultValue: 0},
              asOfDate: {type: 'date', editble: false},
              ccyPairId: {type: 'number', defaultValue: 0},
              curveId: {type: 'number', editable: true},
              curveName: {type: 'string', editable: true},
              value: {type: 'number', validation: {required: true}},
              canDeleted: {type: 'boolean', defaultValue: true},
            },
          },
        },
      }),
    }
  },
  methods: {
    addNew() {
      const grid = this.$refs.grid.kendoWidget()
      grid.addRow()
    },
    curveDropDownEditor(container, options) {
      var isNew = options.model.rateId === 0
      if (isNew) {
        container.selector = '[data-container-for=ccyPairId]'
        return jsonDropDownEditor(
          'ccyPairId',
          'pairCode',
          '/api/heroux/fxRate/getCcyPair',
          {
            dataBound: function() {
              this.trigger('change')
            },
          },
          true,
        ).call(this, container, options)
      }
      return readOnlyEditor.call(this, container, options)
    },
    asOfDateEditor(container, options) {
      var isNew = options.model.rateId === 0
      if (isNew) {
        return datePickerEditor({format: 'yyyy-MM-dd'}, true).call(this, container, options)
      }
      return readOnlyEditor.call(this, container, options)
    },
    exportToExcel() {
      window.location.href = `/api/heroux/fxRate/exportToExcel?t=${this.tokenString}`
    },
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({role: 'authentication/currentRole'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    editable() {
      return this.role != 'Guest'
    },
    columns() {
      return [
        {
          editable: this.editable,
          command: [{name: 'edit'}],
          width: 60,
        },
        {
          field: 'asOfDate',
          width: 110,
          title: 'As Of Date',
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          template: '#= kendo.toString(asOfDate, "yyyy-MM-dd") #',
          format: '{0:yyyy-MM-dd}',
          editor: this.asOfDateEditor,
        },
        {
          field: 'curveName',
          title: 'Currency Pair',
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: center;'},
          width: 150,
          template: '#=curveName#',
          editor: this.curveDropDownEditor,
        },
        {
          field: 'value',
          title: 'Rate',
          width: 150,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          format: '{0:n4}',
          editor: numericEditor({decimals: 6, format: '{0:n4}', spinners: false}),
        },

        {
          editable: this.editable,
          command: [{name: 'destroy', visible: dataItem => dataItem.canDeleted}],
          width: 60,
        },
        {},
      ].filter(c => c.editable !== false)
    },
  },
  components: {
    PageToolbar,
  },
}
</script>
